import React, { memo, useRef, useCallback, useMemo, forwardRef, useImperativeHandle } from 'react';

import DropDown from './dropdown';
import WebSelect from './webselect';

import Navigation from '../../../navigation';
import TextUtils from '../../../textUtils';

import { __WEB__ } from '../../../constants/styles';

const Select = forwardRef((props, ref) => {
  const _compRef = useRef(null);
  useImperativeHandle(ref, () => ({
    validate: (options) => _compRef.current?.validate(options),
  }));

  const value = useMemo(() => {
    if (props.value?.id === undefined) {
      return props.options?.find((o) => o.id === props.value) || null;
    }
    return props.value;
  }, [props.value, props.options]);

  const handleSelected = useCallback(
    (id, item) => {
      props.onValue?.(item);
      props.onSelect?.(item?.id != null ? item?.id : null);
    },
    [props.onValue, props.onSelect]
  );

  const handleWebValue = useCallback(
    (value) => {
      props.onValue?.(value);
      props.onSelect?.(value?.id != null ? value?.id : null);
    },
    [props.onValue, props.onSelect]
  );

  const open = useCallback(() => {
    props.onOpen?.();

    Navigation.showModal({
      screen: 'SuggestionListModal',
      title: TextUtils.ac(props.title || props.label || ''),
      passProps: {
        items: props.options,
        onValue: handleSelected,
        selectedId: value?.id,
        closeOnSelect: true,
        restrictToListValues: true,
      },
      options: {
        noNavBar: true,
        containerStyle: { backgroundColor: 'transparent' },
        screenContainerStyle: { backgroundColor: 'transparent' },
      },
    });
  }, [props.options, props.title, props.label, value, props.closeOnSelect, handleSelected]);

  if (__WEB__ && !!props.webMode) {
    return (
      <WebSelect
        ref={_compRef}
        required={props.required}
        editable={props.editable}
        disabled={!!props.disabled}
        containerStyle={props.containerStyle}
        flexibleHeight={props.flexibleHeight}
        menuPlacement={props.menuPlacement}
        menuPortalTarget={props.menuPortalTarget}
        label={props.label}
        value={value}
        onValue={handleWebValue}
        options={props.options}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        styles={props.styles}
        selectContainerStyle={props.selectContainerStyle}
        placeholder={props.placeholder}
        isClearable={props.isClearable}
        noLabel={props.noLabel}
        testID={props.label}
        tipText={props.tipText}
      />
    );
  }

  return (
    <DropDown
      ref={_compRef}
      required={props.required}
      editable={props.editable}
      disabled={!!props.disabled}
      placeholder={props.placeholder}
      label={props.label}
      value={value?.label}
      onPress={open}
      containerStyle={props.nativeContainerStyle}
      buttonStyle={props.nativeButtonStyle}
      arrowIconStyle={props.nativeArrowIconStyle}
      buttonValueTextStyle={props.valueStyle}
      buttonValueTextContainerStyle={props.valueContainerStyle}
      styleType={props.nativeStyleType}
      fieldLabelStyle={props.fieldLabelStyle}
      testID={props.label}
      tipText={props.tipText}
    />
  );
});
export default memo(Select);
